module.exports = __webpack_public_path__ + "img/tongxulu.2ec036e2.jpg";